<template>
  <b-card>
    <!-- Sections List -->
    <b-card-actions
      action-collapse
      collapsed
    >
      <template #title>
        <div
          class="text-capitalize"
        >
          <h4>{{ permissionsGroup.title }}</h4>
          <small>{{ permissionsGroup.description }}</small>
        </div>
      </template>
      <b-card-text>
        <b-checkbox
          :checked="isOnePermissionSelected"
          @change="toggle"
        >
          {{ isOnePermissionSelected ? 'Deselect All' : 'Select All' }}
        </b-checkbox>
        <b-checkbox-group
          v-model="selectedPermissionsProxy"
          :options="permissionsGroup.permissions"
          stacked
          text-field="displayName"
          value-field="id"
        />
      </b-card-text>
    </b-card-actions>
  </b-card>
</template>

<script>
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'

export default {
  name: 'PermissionsGroupCard',
  components: { BCardActions },
  props: {
    permissionsGroup: { type: Object, default: () => {} },
    selectedPermissions: { type: Array, default: () => [] },
  },
  computed: {
    selectedPermissionsProxy: {
      get() {
        return this.selectedPermissions
      },
      set(value) {
        this.$emit('update:selectedPermissions', value)
      },
    },
    isOnePermissionSelected() {
      return this.groupPermissionsId.some(id => this.selectedPermissions.includes(id))
    },
    groupPermissionsId() {
      return this.permissionsGroup.permissions.map(permission => permission.id)
    },
  },
  methods: {
    toggle() {
      if (this.isOnePermissionSelected) {
        this.selectedPermissionsProxy = this.removeFromArray(this.selectedPermissions, this.groupPermissionsId)
      } else {
        this.selectedPermissionsProxy.push(...this.groupPermissionsId)
      }
    },
    removeFromArray(original, remove) {
      return original.filter(value => !remove.includes(value))
    },
  },
}
</script>

<style>

</style>
